import { Chart } from "../Chart";
import { ISeriesApi } from "../lcharts/src/api/iseries-api";
import { LineStyle } from "src/app/Models/lcharts/src/renderers/draw-line";
import { BarPrice } from "../lcharts/src/model/bar";
import { LineWave } from "../LineSerie";
import { IPriceLine } from "../lcharts/src/api/iprice-line";
import { LineData } from "../lcharts/src/api/data-consumer";
import { BusinessDay, UTCTimestamp } from "lightweight-charts";
import * as jQuery from "jquery";
import { priceToY, yToPrice } from "./Annotations";
import { DGDrawingServiceGlobal } from "src/app/Services/DrawingService";
import { MatDialog } from "@angular/material/dialog";
import { PriceLineSettingsDialogComponent } from "src/app/Dialogs/priceLIneSettings/priceLIneSettings.component";
import { UpdateAnnotationReq } from "src/app/Services/dg-hub-client.service";
import { LoggerService } from "src/app/Services/Logger/Logger";
import { AnnotationTypes } from "../HubModels";
import { Coordinate } from "../lcharts/src/model/coordinate";
export class AnnotationPriceLines {
  public priceLinesSerie: ISeriesApi<"Line">;
  public priceLines: PriceLineItem[] = [];
  public idsCounter: number = 0;

  constructor(public chart: Chart) {
    this.priceLinesSerie = this.chart.chart.addLineSeries(
      LineWave.transparentSerieOptions(),
      0
    );
  }

  public pricelInePoints: LineData[] = [];
  addNewPriceLine(
    priceValue: number,
    time: UTCTimestamp | BusinessDay,
    add?: boolean,
    init?: boolean,
    color?: string,
    isSignal?: boolean
  ): IPriceLine {
    let point: LineData = {
      time: DGDrawingServiceGlobal.drawingService().lastTIme,
      value: priceValue,
    };

    this.pricelInePoints.push(point);
    this.priceLinesSerie.setData(this.pricelInePoints);

    const priceLine = this.priceLinesSerie.createPriceLine({
      axisLabelVisible: true,
      color: "#FFFFFF",
      lineStyle: LineStyle.Solid,
      lineWidth: 1,
      price: priceValue as BarPrice,
      isSignal: isSignal,
    });

    if (add) {
      this.priceLines.push({
        priceline: priceLine,
        id: `pl_${this.idsCounter}`,
      });
      let y = priceToY(priceLine.options().price, this.chart.chart);

      if (!init) {
        const dialogRef = DGDrawingServiceGlobal.drawingService().dialog.open(
          PriceLineSettingsDialogComponent,
          {
            width: "auto",
          }
        );

        dialogRef.afterClosed().subscribe((v) => {
          if (v == true) {
            priceLine.applyOptions({
              color: dialogRef.componentInstance.color,
              isSignal: dialogRef.componentInstance.isSignal,
            });

            DGDrawingServiceGlobal.drawingService().annotations.annotationPriceLines.saveState();

            if (dialogRef.componentInstance.isSignal) {
              jQuery(`#cc_pl_${this.idsCounter - 1}`).css({
                backgroundColor: "red",
              });
            }
          } else {
            let pl =
              DGDrawingServiceGlobal.drawingService().annotations.annotationPriceLines.priceLines.find(
                (v) => {
                  return v.priceline == priceLine;
                }
              );

            DGDrawingServiceGlobal.drawingService().annotations.annotationPriceLines.removePriceLIne(
              priceLine,
              pl.id
            );
          }
        });
      } else {
        priceLine.applyOptions({ color: color });
      }

      this.addPriceLineHandler(y, `pl_${this.idsCounter}`, priceLine, init);
      this.idsCounter++;
    }

    return priceLine;
  }

  colorTm: any;
  playTm: any;
  public activateSignal(id: string) {
    let priceLine = this.priceLines.find((l) => {
      return l.id == id;
    });

    if (priceLine.priceline.options().isSignal) {
      priceLine.priceline.applyOptions({ isSignal: false });
      DGDrawingServiceGlobal.drawingService().annotations.annotationPriceLines.saveState();

      clearTimeout(this.colorTm);
      clearTimeout(this.playTm);

      const signalIco = `cc_${id}`;

      jQuery(`#${signalIco}`).css({ backgroundColor: "#E4007C" });

      this.colorTm = setTimeout(() => {
        jQuery(`#${signalIco}`).css({ backgroundColor: "yellow" });
      }, 60000);

      this.playTm = setTimeout(() => {
        DGDrawingServiceGlobal.drawingService().signal.play();
      }, 30000);
    }
  }

  removePriceLIne(priceLine: IPriceLine, id?: string) {
    this.priceLinesSerie.removePriceLine(priceLine);

    if (id) {
      jQuery(`#c_${id}`).remove();
      jQuery(`#cc_${id}`).remove();
      jQuery(`#l_${id}`).remove();
    }
  }

  updatePriceLine(priceLine: IPriceLine, priceValue: number) {
    priceLine.applyOptions({ price: priceValue as BarPrice });
  }

  public menuButtonSize: number = 20;
  public update() {
    this.priceLines.forEach((v) => {
      // //console.log(v.priceline.options().price)
      if (this.chart.chart != null) {
        let y = priceToY(v.priceline.options().price, this.chart.chart);

        // this.addPriceLineHandler(y, v.id);
        let currentWidth =
          DGDrawingServiceGlobal.drawingService().getCanvasElement(
            "tist_0"
          ).width;
        let currentHeight =
          DGDrawingServiceGlobal.drawingService().getCanvasElement(
            "tist_0"
          ).height;

        let visibility = "visible";

        if (y < 0 || y > currentHeight) visibility = "hidden";

        let priceLineHandlerWidth = v.priceline.options().lineWidth;
        jQuery(`#l_${v.id}`).css({
          top: `${y - 2 * priceLineHandlerWidth}px`,
          width: `${currentWidth}px`,
          visibility: `${visibility}`,
        });

        jQuery(`#c_${v.id}`).css({
          top: `${y - this.menuButtonSize - priceLineHandlerWidth}px`,
          width: `${this.menuButtonSize}px`,
          visibility: `${visibility}`,
        });
        jQuery(`#cc_${v.id}`).css({
          top: `${y - this.menuButtonSize - priceLineHandlerWidth}px`,
          width: `${this.menuButtonSize}px`,
          visibility: `${visibility}`,
        });
      }
    });
  }

  public addPriceLineHandler(y, id, priceLine: IPriceLine, init?: boolean) {
    let currentWidth =
      DGDrawingServiceGlobal.drawingService().getCanvasElement("tist_0").width;
    let priceLineHandlerWidth = 2 * priceLine.options().lineWidth;

    jQuery("#chartWrapper").append(
      `<div att-id="${id}" style=" top: ${
        y - 6 * priceLineHandlerWidth
      }px; left: 10px; width:${currentWidth}px; height:${
        6 * priceLineHandlerWidth
      }px"  class='priceLineHandler' id='l_${id}'></div>`
    );
    jQuery("#chartWrapper").append(
      `<div att-id="${id}" style="top: ${
        y - this.menuButtonSize - priceLineHandlerWidth
      }px; left: 15px; width:${this.menuButtonSize}px; height:${
        this.menuButtonSize
      }px;"  class='priceLineHandlerClose' id='c_${id}'>x</div>`
    );

    if (!init) {
      jQuery("#chartWrapper").append(
        `<div att-id="${id}" style="top: ${
          y - this.menuButtonSize - priceLineHandlerWidth + 1
        }px; left: 45px; width:${this.menuButtonSize}px; height:${
          this.menuButtonSize
        }px;"  class='priceLineHandlerConfig' id='cc_${id}'><mat-icon style="position:relative;right:2px;top:-2px" role="img" class="mat-icon notranslate material-icons mat-icon-no-color ng-tns-c121-1" aria-hidden="true">settings</mat-icon></i></div>`
      );
    } else {
      if (priceLine.options().isSignal) {
        jQuery("#chartWrapper").append(
          `<div att-id="${id}" style="background-color:red;top: ${
            y - this.menuButtonSize - priceLineHandlerWidth + 1
          }px; left: 45px; width:${this.menuButtonSize}px; height:${
            this.menuButtonSize
          }px;"  class='priceLineHandlerConfig' id='cc_${id}'><mat-icon style="position:relative;right:2px;top:-2px" role="img" class="mat-icon notranslate material-icons mat-icon-no-color ng-tns-c121-1" aria-hidden="true">settings</mat-icon></i></div>`
        );
      } else {
        jQuery("#chartWrapper").append(
          `<div att-id="${id}" style="top: ${
            y - this.menuButtonSize - priceLineHandlerWidth + 1
          }px; left: 45px; width:${this.menuButtonSize}px; height:${
            this.menuButtonSize
          }px;"  class='priceLineHandlerConfig' id='cc_${id}'><mat-icon style="position:relative;right:2px;top:-2px" role="img" class="mat-icon notranslate material-icons mat-icon-no-color ng-tns-c121-1" aria-hidden="true">settings</mat-icon></i></div>`
        );
      }
    }

    jQuery(`#c_${id}`).on("click", function () {
      const model =
        DGDrawingServiceGlobal.drawingService().annotations
          .annotationPriceLines;

      let lines = model.priceLines;
      let priceline = model.findPriceLineById(jQuery(this).attr("att-id"));

      model.removePriceLIne(priceline.priceline);

      jQuery(`#c_${id}`).remove();
      jQuery(`#cc_${id}`).remove();
      jQuery(`#l_${id}`).remove();

      let i = model.priceLines.indexOf(priceline);

      model.priceLines.splice(i, 1);

      model.saveState();
    });
    jQuery(`#cc_${id}`).on("click", function () {
      const model =
        DGDrawingServiceGlobal.drawingService().annotations
          .annotationPriceLines;
      let priceline = model.findPriceLineById(jQuery(this).attr("att-id"));
      //console.log(priceline);

      const dialogRef = DGDrawingServiceGlobal.drawingService().dialog.open(
        PriceLineSettingsDialogComponent,
        {
          width: "auto",
          data: {
            id: jQuery(this).attr("att-id"),
            color: priceline.priceline.options().color,
            isSignal: priceline.priceline.options().isSignal,
          },
        }
      );

      dialogRef.afterClosed().subscribe((v) => {
        if (v == true) {
          priceLine.applyOptions({
            color: dialogRef.componentInstance.color,
            isSignal: dialogRef.componentInstance.isSignal,
          });
          DGDrawingServiceGlobal.drawingService().annotations.annotationPriceLines.saveState();

          if (dialogRef.componentInstance.isSignal) {
            jQuery(`#cc_${id}`).css({ backgroundColor: "red" });
          } else {
            jQuery(`#cc_${id}`).css({ backgroundColor: "yellow" });
          }
        }
      });
    });

    jQuery(`#l_${id}`).on("click", function () {
      const model =
        DGDrawingServiceGlobal.drawingService().annotations
          .annotationPriceLines;

      model.activeItem = model.findPriceLineById(jQuery(this).attr("att-id"));
      model.traceMousePosition();
      jQuery(this).css({ opacity: 0.75, pointerEvents: "none" });
    });
  }

  public findPriceLineById(id: string) {
    let priceline =
      DGDrawingServiceGlobal.drawingService().annotations.annotationPriceLines.priceLines.find(
        (k) => {
          return k.id == id;
        }
      );
    return priceline;
  }

  public canvasItem: HTMLCanvasElement;
  public traceMousePosition() {
    let canvasItem =
      DGDrawingServiceGlobal.drawingService().getCanvasElement("tist_0");
    canvasItem.addEventListener("mousemove", this.onMouseMove, false);
    canvasItem.addEventListener("mousedown", this.onMouseClick, false);
    canvasItem.addEventListener("touchstart", this.onMouseClick, false);
  }

  public onMouseMove(evt) {
    const model =
      DGDrawingServiceGlobal.drawingService().annotations.annotationPriceLines;

    let active = model.activeItem;
    let position =
      DGDrawingServiceGlobal.drawingService().annotations.getMousePos(
        DGDrawingServiceGlobal.drawingService().annotations.canvasItem,
        evt
      );
    let priceValue = yToPrice(
      position.y as Coordinate,
      DGDrawingServiceGlobal.drawingService().annotations.chart.chart
    );

    model.updatePriceLine(active.priceline, priceValue);
    let yOffset = model.menuButtonSize - active.priceline.options().lineWidth;
    let linewOffset = 6 * active.priceline.options().lineWidth;
    jQuery(`#c_${active.id}`).css({ top: `${position.y - yOffset}px` });
    jQuery(`#cc_${active.id}`).css({ top: `${position.y - yOffset - 2}px` });
    jQuery(`#l_${active.id}`).css({ top: `${position.y - linewOffset}px` });
  }

  public onMouseClick(evt) {
    const model =
      DGDrawingServiceGlobal.drawingService().annotations.annotationPriceLines;
    let canvasItem =
      DGDrawingServiceGlobal.drawingService().annotations.canvasItem;

    canvasItem.removeEventListener("mousemove", model.onMouseMove, false);
    canvasItem.removeEventListener("mousedown", model.onMouseClick, false);
    canvasItem.removeEventListener("touchstart", model.onMouseClick, false);

    let active = model.activeItem;
    let position =
      DGDrawingServiceGlobal.drawingService().annotations.getMousePos(
        DGDrawingServiceGlobal.drawingService().annotations.canvasItem,
        evt
      );
    let priceValue = yToPrice(
      position.y as Coordinate,
      DGDrawingServiceGlobal.drawingService().annotations.chart.chart
    );

    model.updatePriceLine(active.priceline, priceValue);

    model.activeItem = null;

    jQuery(`#l_${active.id}`).css({ pointerEvents: "auto", opacity: 0 });

    model.saveState();
  }

  private _activeItem: PriceLineItem = null;
  public get activeItem(): PriceLineItem {
    return this._activeItem;
  }
  public set activeItem(value: PriceLineItem) {
    this._activeItem = value;
  }

  public collectData() {
    let data: priceLineData[] = [];
    this.priceLines.forEach((v) => {
      data.push({
        price: Number(v.priceline.options().price),
        color: v.priceline.options().color,
        isSignal: v.priceline.options().isSignal,
      });
    });
    return JSON.stringify(data);
  }

  public saveState() {
    let updateAnnotation = new UpdateAnnotationReq();
    updateAnnotation.viewName =
      DGDrawingServiceGlobal.drawingService().selectedViewName == null
        ? "null"
        : DGDrawingServiceGlobal.drawingService().selectedViewName;
    updateAnnotation.data = this.collectData();
    updateAnnotation.type = AnnotationTypes.PRICELINE;
    DGDrawingServiceGlobal.drawingService()
      .dataService.getHubCLientService()
      .updateAnnotation(updateAnnotation)
      .then((v) => {})
      .catch((e) => {
        LoggerService.logError(e);
      });
  }
}

export interface PriceLineItem {
  priceline: IPriceLine;
  id: string;
}

export interface priceLineData {
  price: number;
  color: string;
  isSignal: boolean;
}
